"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var Filter = function Filter(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "filter",
    viewBox: "0 0 16 16"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-1119.000000, -33.000000)",
    fill: "#000000"
  }, react_1["default"].createElement("g", {
    transform: "translate(1107.000000, 21.000000)"
  }, react_1["default"].createElement("g", {
    transform: "translate(10.000000, 10.000000)"
  }, react_1["default"].createElement("path", {
    d: "M11.25,17.5 L8.75,17.5 C8.05964406,17.5 7.5,16.9403559 7.5,16.25 L7.5,11.50625 L2.86875,6.875 C2.63400763,6.64165607 2.50139549,6.32473553 2.5,5.99375 L2.5,3.75 C2.5,3.05964406 3.05964406,2.5 3.75,2.5 L16.25,2.5 C16.9403559,2.5 17.5,3.05964406 17.5,3.75 L17.5,5.99375 C17.4986045,6.32473553 17.3659924,6.64165607 17.13125,6.875 L12.5,11.50625 L12.5,16.25 C12.5,16.9403559 11.9403559,17.5 11.25,17.5 Z M3.75,3.75 L3.75,5.99375 L8.75,10.99375 L8.75,16.25 L11.25,16.25 L11.25,10.99375 L16.25,5.99375 L16.25,3.75 L3.75,3.75 Z"
  }))))));
};

exports["default"] = Filter;